import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../../shared";
import { DataService_MultiStationSettings } from "../shared/data.service";
import { DistrictSettingsUpdateRequest } from "../shared/DistrictSettingsUpdateRequest";
import { FacilitySettingsUpdateRequest } from "../shared/FacilitySettingsUpdateRequest";

@Component({
	selector: "caass-multistation-facility-settings",
	templateUrl: "./multistation-facility-settings.component.html",
	styleUrls: ["./multistation-facility-settings.component.css"],
})
export class MultistationFacilitySettingsComponent implements OnInit {
	constructor(private userService: UserService, private dataService: DataService_MultiStationSettings, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
		if (this.user.userID == 0) {
			this.IsSU = true;
		}

		this.loadFacilities();
		// this.loadData();
	}

	///////////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////////

	SelectedFacility: any;
	lstFacility: any;

	//
	//  Preferences from DB
	//
	A411_District_VisitorModeEnabled: boolean = false;
	A411_District_StudentModeEnabled: boolean = false;
	A411_District_StaffModeEnabled: boolean = false;
	A411_District_OffenderLookupEnabled: boolean = false;
	A411_Facility_VisitorModeEnabled: boolean = false;
	A411_Facility_StudentModeEnabled: boolean = false;
	A411_Facility_StaffModeEnabled: boolean = false;
	A411_Facility_OffenderLookupEnabled: boolean = false;
	FacilitySettingsExist: boolean = false;
	VisitorModeEnabled: boolean = false;
	VisitorModeCanOverride: boolean = false;
	StudentModeEnabled: boolean = false;
	StudentModeCanOverride: boolean = false;
	StaffModeEnabled: boolean = false;
	StaffModeCanOverride: boolean = false;
	OffenderLookupEnabled: boolean = false;
	OffenderLookupCanOverride: boolean = false;
	PanicButtonEnabled: boolean = false;
	PanicButtonCanOverride: boolean = false;
	ConfirmPanicButtonEnabled: boolean = false;
	ConfirmPanicButtonCanOverride: boolean = false;
	PanicButtonText: string = "";
	PanicButtonTextCanOverride: boolean = false;
	ConfirmPanicButtonText: string = "";
	ConfirmPanicButtonTextCanOverride: boolean = false;
	Default_PanicButtonTopicID: number = -1;
	PanicButtonTopicCanOverride: boolean = false;
	PhotoRequired: boolean = false;
	PhotoRequiredCanOverride: boolean = false;
	SkipPhotoIfNotRequired: boolean = false;
	SkipPhotoIfNotRequiredCanOverride: boolean = false;
	UseDriversLicensePhoto: boolean = false;
	UseDriversLicensePhotoCanOverride: boolean = false;
	AllowExistingPhoto: boolean = false;
	AllowExistingPhotoCanOverride: boolean = false;
	ForceRetakePhotoAfterXDays: number = 0;
	ForceRetakePhotoCanOverride: boolean = false;
	Default_PrinterAlignTop: number = 0;
	Default_PrinterAlignLeft: number = 0;
	PrintStudentLatePasses: boolean = false;
	PrintStudentLatePassesCanOverride: boolean = false;
	PrintStudentEntryPasses: boolean = false;
	PrintStudentEntryPassesCanOverride: boolean = false;
	SkipConfirmInfo: boolean = false;
	SkipConfirmInfoCanOverride: boolean = false;
	SkipVisitorType: boolean = false;
	SkipVisitorTypeCanOverride: boolean = false;
	DefaultVisitorTypeID: number = -1;
	DefaultVisitorTypeCanOverride: boolean = false;
	SkipVisitee: boolean = false;
	SkipVisiteeCanOverride: boolean = false;
	DefaultVisiteeSchoolID: number = -1;
	DefaultVisiteeID: number = -1;
	DefaultVisiteeCanOverride: boolean = false;
	DefaultVisiteeFacilityLocationID: number = -1;
	SkipVisitReason: boolean = false;
	SkipVisitReasonCanOverride: boolean = false;
	DefaultVisitReasonID: number = -1;
	DefaultVisitReasonCanOverride: boolean = false;
	SkipAdditionalNotes: boolean = false;
	SkipAdditionalNotesCanOverride: boolean = false;
	SkipSignature: boolean = false;
	SkipSignatureCanOverride: boolean = false;
	UseDriversLicenseSignature: boolean = false;
	UseDriversLicenseSignatureCanOverride: boolean = false;
	SelfCheckInVerifyText: string = "";
	SelfCheckInVerifyTextCanOverride: boolean = false;
	Default_KeyboardMode: number = 0;
	Default_FacilityLocationID: number = 0;
	SyncDropdownMinutes: number = 0;
	SyncDropdownMinutesCanOverride: boolean = false;
	StationMode: number = 0;
	StationModeCanOverride: boolean = false;
	Template_OffenderHit: string = "";
	Template_VerificationReqd: string = "";
	Template_Default: string = "";
	Template_OffenderHitCanOverride: boolean = false;
	Template_VerificationReqdCanOverride: boolean = false;
	Template_DefaultCanOverride: boolean = false;
	CurrentVersion: string;
	c_Date: Date = new Date();
	c_DateDesc: string = "";
	District_VisitorModeCanOverride: boolean = false;
	District_StudentModeCanOverride: boolean = false;
	District_StaffModeCanOverride: boolean = false;
	District_OffenderLookupCanOverride: boolean = false;
	District_PanicButtonCanOverride: boolean = false;
	District_ConfirmPanicButtonCanOverride: boolean = false;
	District_PanicButtonTextCanOverride: boolean = false;
	District_ConfirmPanicButtonTextCanOverride: boolean = false;
	District_PanicButtonTopicCanOverride: boolean = false;
	District_PhotoRequiredCanOverride: boolean = false;
	District_SkipPhotoIfNotRequiredCanOverride: boolean = false;
	District_UseDriversLicensePhotoCanOverride: boolean = false;
	District_AllowExistingPhotoCanOverride: boolean = false;
	District_ForceRetakePhotoCanOverride: boolean = false;
	District_PrintStudentLatePassesCanOverride: boolean = false;
	District_PrintStudentEntryPassesCanOverride: boolean = false;
	District_SkipConfirmInfoCanOverride: boolean = false;
	District_SkipVisitorTypeCanOverride: boolean = false;
	District_DefaultVisitorTypeCanOverride: boolean = false;
	District_SkipVisiteeCanOverride: boolean = false;
	District_DefaultVisiteeCanOverride: boolean = false;
	District_SkipVisitReasonCanOverride: boolean = false;
	District_DefaultVisitReasonCanOverride: boolean = false;
	District_SkipAdditionalNotesCanOverride: boolean = false;
	District_SkipSignatureCanOverride: boolean = false;
	District_UseDriversLicenseSignatureCanOverride: boolean = false;
	District_SelfCheckInVerifyTextCanOverride: boolean = false;
	District_SyncDropdownMinutesCanOverride: boolean = false;
	District_StationModeCanOverride: boolean = false;
	District_Template_OffenderHitCanOverride: boolean = false;
	District_Template_VerificationReqdCanOverride: boolean = false;
	District_Template_DefaultCanOverride: boolean = false;

	SelectedVisitee: any;

	lstIDCardTemplate: any = [];
	lstVisitorType: any = [];
	lstVisitReason: any = [];
	lstVisitee: any = [];
	lstPanicButtonTopic: any = [];
	lstFacilityLocation: any = [];
	lstKeyboardMode: any = [];
	lstStationMode: any = [];

	//
	//  Misc
	//
	user: any;
	IsSU: boolean = false;

	//
	//  Loading
	//
	errorMessage: string = "";

	FacilityLoading: boolean = false;
	PreferenceLoading: boolean = false;
	Processing: boolean = false;

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////////////////

	loadFacilities() {
		this.errorMessage = "";
		this.FacilityLoading = true;

		var result = this.dataService.SettingsFacilitySelectList();
		result.subscribe(
			(response: any) => {
				this.lstFacility = response;

				this.onFacilityChange(this.lstFacility[0]);

				this.FacilityLoading = false;
			},
			(error) => {
				this.FacilityLoading = false;
			}
		);
	}

	loadData() {
		this.errorMessage = "";
		this.PreferenceLoading = true;

		var result = this.dataService.FacilitySettingsSelect(this.SelectedFacility.ID);
		result.subscribe(
			(response: any) => {
				this.A411_District_VisitorModeEnabled = response.A411_District_VisitorModeEnabled;
				this.A411_District_StudentModeEnabled = response.A411_District_StudentModeEnabled;
				this.A411_District_StaffModeEnabled = response.A411_District_StaffModeEnabled;
				this.A411_District_OffenderLookupEnabled = response.A411_District_OffenderLookupEnabled;
				this.A411_Facility_VisitorModeEnabled = response.A411_Facility_VisitorModeEnabled;
				this.A411_Facility_StudentModeEnabled = response.A411_Facility_StudentModeEnabled;
				this.A411_Facility_StaffModeEnabled = response.A411_Facility_StaffModeEnabled;
				this.A411_Facility_OffenderLookupEnabled = response.A411_Facility_OffenderLookupEnabled;
				this.FacilitySettingsExist = response.FacilitySettingsExist;
				this.VisitorModeEnabled = response.VisitorModeEnabled;
				this.VisitorModeCanOverride = response.VisitorModeCanOverride;
				this.StudentModeEnabled = response.StudentModeEnabled;
				this.StudentModeCanOverride = response.StudentModeCanOverride;
				this.StaffModeEnabled = response.StaffModeEnabled;
				this.StaffModeCanOverride = response.StaffModeCanOverride;
				this.OffenderLookupEnabled = response.OffenderLookupEnabled;
				this.OffenderLookupCanOverride = response.OffenderLookupCanOverride;
				this.PanicButtonEnabled = response.PanicButtonEnabled;
				this.PanicButtonCanOverride = response.PanicButtonCanOverride;
				this.ConfirmPanicButtonEnabled = response.ConfirmPanicButtonEnabled;
				this.ConfirmPanicButtonCanOverride = response.ConfirmPanicButtonCanOverride;
				this.PanicButtonText = response.PanicButtonText;
				this.PanicButtonTextCanOverride = response.PanicButtonTextCanOverride;
				this.ConfirmPanicButtonText = response.ConfirmPanicButtonText;
				this.ConfirmPanicButtonTextCanOverride = response.ConfirmPanicButtonTextCanOverride;
				this.Default_PanicButtonTopicID = response.Default_PanicButtonTopicID;
				this.PanicButtonTopicCanOverride = response.PanicButtonTopicCanOverride;
				this.PhotoRequired = response.PhotoRequired;
				this.PhotoRequiredCanOverride = response.PhotoRequiredCanOverride;
				this.SkipPhotoIfNotRequired = response.SkipPhotoIfNotRequired;
				this.SkipPhotoIfNotRequiredCanOverride = response.SkipPhotoIfNotRequiredCanOverride;
				this.UseDriversLicensePhoto = response.UseDriversLicensePhoto;
				this.UseDriversLicensePhotoCanOverride = response.UseDriversLicensePhotoCanOverride;
				this.AllowExistingPhoto = response.AllowExistingPhoto;
				this.AllowExistingPhotoCanOverride = response.AllowExistingPhotoCanOverride;
				this.ForceRetakePhotoAfterXDays = response.ForceRetakePhotoAfterXDays;
				this.ForceRetakePhotoCanOverride = response.ForceRetakePhotoCanOverride;
				this.Default_PrinterAlignTop = response.Default_PrinterAlignTop;
				this.Default_PrinterAlignLeft = response.Default_PrinterAlignLeft;
				this.PrintStudentLatePasses = response.PrintStudentLatePasses;
				this.PrintStudentLatePassesCanOverride = response.PrintStudentLatePassesCanOverride;
				this.PrintStudentEntryPasses = response.PrintStudentEntryPasses;
				this.PrintStudentEntryPassesCanOverride = response.PrintStudentEntryPassesCanOverride;
				this.SkipConfirmInfo = response.SkipConfirmInfo;
				this.SkipConfirmInfoCanOverride = response.SkipConfirmInfoCanOverride;
				this.SkipVisitorType = response.SkipVisitorType;
				this.SkipVisitorTypeCanOverride = response.SkipVisitorTypeCanOverride;
				this.DefaultVisitorTypeID = response.DefaultVisitorTypeID;
				this.DefaultVisitorTypeCanOverride = response.DefaultVisitorTypeCanOverride;
				this.SkipVisitee = response.SkipVisitee;
				this.SkipVisiteeCanOverride = response.SkipVisiteeCanOverride;
				this.DefaultVisiteeSchoolID = response.DefaultVisiteeSchoolID;
				this.DefaultVisiteeID = response.DefaultVisiteeID;
				this.DefaultVisiteeCanOverride = response.DefaultVisiteeCanOverride;
				this.DefaultVisiteeFacilityLocationID = response.DefaultVisiteeFacilityLocationID;
				this.SkipVisitReason = response.SkipVisitReason;
				this.SkipVisitReasonCanOverride = response.SkipVisitReasonCanOverride;
				this.DefaultVisitReasonID = response.DefaultVisitReasonID;
				this.DefaultVisitReasonCanOverride = response.DefaultVisitReasonCanOverride;
				this.SkipAdditionalNotes = response.SkipAdditionalNotes;
				this.SkipAdditionalNotesCanOverride = response.SkipAdditionalNotesCanOverride;
				this.SkipSignature = response.SkipSignature;
				this.SkipSignatureCanOverride = response.SkipSignatureCanOverride;
				this.UseDriversLicenseSignature = response.UseDriversLicenseSignature;
				this.UseDriversLicenseSignatureCanOverride = response.UseDriversLicenseSignatureCanOverride;
				this.SelfCheckInVerifyText = response.SelfCheckInVerifyText;
				this.SelfCheckInVerifyTextCanOverride = response.SelfCheckInVerifyTextCanOverride;
				this.Default_KeyboardMode = response.Default_KeyboardMode;
				this.Default_FacilityLocationID = response.Default_FacilityLocationID;
				this.SyncDropdownMinutes = response.SyncDropdownMinutes;
				this.SyncDropdownMinutesCanOverride = response.SyncDropdownMinutesCanOverride;
				this.StationMode = response.StationMode;
				this.StationModeCanOverride = response.StationModeCanOverride;
				this.Template_OffenderHit = response.Template_OffenderHit;
				this.Template_VerificationReqd = response.Template_VerificationReqd;
				this.Template_Default = response.Template_Default;
				this.Template_OffenderHitCanOverride = response.Template_OffenderHitCanOverride;
				this.Template_VerificationReqdCanOverride = response.Template_VerificationReqdCanOverride;
				this.Template_DefaultCanOverride = response.Template_DefaultCanOverride;
				this.CurrentVersion = response.CurrentVersion;
				this.c_Date = new Date(response.c_Date);
				this.c_DateDesc = response.c_DateDesc;
				this.District_VisitorModeCanOverride = response.District_VisitorModeCanOverride;
				this.District_StudentModeCanOverride = response.District_StudentModeCanOverride;
				this.District_StaffModeCanOverride = response.District_StaffModeCanOverride;
				this.District_OffenderLookupCanOverride = response.District_OffenderLookupCanOverride;
				this.District_PanicButtonCanOverride = response.District_PanicButtonCanOverride;
				this.District_ConfirmPanicButtonCanOverride = response.District_ConfirmPanicButtonCanOverride;
				this.District_PanicButtonTextCanOverride = response.District_PanicButtonTextCanOverride;
				this.District_ConfirmPanicButtonTextCanOverride = response.District_ConfirmPanicButtonTextCanOverride;
				this.District_PanicButtonTopicCanOverride = response.District_PanicButtonTopicCanOverride;
				this.District_PhotoRequiredCanOverride = response.District_PhotoRequiredCanOverride;
				this.District_SkipPhotoIfNotRequiredCanOverride = response.District_SkipPhotoIfNotRequiredCanOverride;
				this.District_UseDriversLicensePhotoCanOverride = response.District_UseDriversLicensePhotoCanOverride;
				this.District_AllowExistingPhotoCanOverride = response.District_AllowExistingPhotoCanOverride;
				this.District_ForceRetakePhotoCanOverride = response.District_ForceRetakePhotoCanOverride;
				this.District_PrintStudentLatePassesCanOverride = response.District_PrintStudentLatePassesCanOverride;
				this.District_PrintStudentEntryPassesCanOverride = response.District_PrintStudentEntryPassesCanOverride;
				this.District_SkipConfirmInfoCanOverride = response.District_SkipConfirmInfoCanOverride;
				this.District_SkipVisitorTypeCanOverride = response.District_SkipVisitorTypeCanOverride;
				this.District_DefaultVisitorTypeCanOverride = response.District_DefaultVisitorTypeCanOverride;
				this.District_SkipVisiteeCanOverride = response.District_SkipVisiteeCanOverride;
				this.District_DefaultVisiteeCanOverride = response.District_DefaultVisiteeCanOverride;
				this.District_SkipVisitReasonCanOverride = response.District_SkipVisitReasonCanOverride;
				this.District_DefaultVisitReasonCanOverride = response.District_DefaultVisitReasonCanOverride;
				this.District_SkipAdditionalNotesCanOverride = response.District_SkipAdditionalNotesCanOverride;
				this.District_SkipSignatureCanOverride = response.District_SkipSignatureCanOverride;
				this.District_UseDriversLicenseSignatureCanOverride = response.District_UseDriversLicenseSignatureCanOverride;
				this.District_SelfCheckInVerifyTextCanOverride = response.District_SelfCheckInVerifyTextCanOverride;
				this.District_SyncDropdownMinutesCanOverride = response.District_SyncDropdownMinutesCanOverride;
				this.District_StationModeCanOverride = response.District_StationModeCanOverride;
				this.District_Template_OffenderHitCanOverride = response.District_Template_OffenderHitCanOverride;
				this.District_Template_VerificationReqdCanOverride = response.District_Template_VerificationReqdCanOverride;
				this.District_Template_DefaultCanOverride = response.District_Template_DefaultCanOverride;

				this.lstIDCardTemplate = response.lstIDCardTemplate;
				this.lstVisitorType = response.lstVisitorType;
				this.lstVisitReason = response.lstVisitReason;
				this.lstVisitee = response.lstVisitee;
				this.lstPanicButtonTopic = response.lstPanicButtonTopic;
				this.lstFacilityLocation = response.lstFacilityLocation;
				this.lstKeyboardMode = response.lstKeyboardMode;
				this.lstStationMode = response.lstStationMode;

				//
				//	Update Dropdowns
				//
				this.UpdateSelected();

				this.PreferenceLoading = false;
			},
			(error) => {
				this.PreferenceLoading = false;
			}
		);
	}

	UpdateSelected() {
		var temp = -1;

		//
		//	DefaultVisitorTypeID
		//
		temp = -1;
		if (this.lstVisitorType.length > 0) {
			temp = this.lstVisitorType[0].ID;
			for (var z = 0; z < this.lstVisitorType.length; z++) {
				var next = this.lstVisitorType[z];

				if (this.DefaultVisitorTypeID == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.DefaultVisitorTypeID = Number(temp);

		//
		//	DefaultVisitReasonID
		//
		temp = -1;
		if (this.lstVisitReason.length > 0) {
			temp = this.lstVisitReason[0].ID;
			for (var z = 0; z < this.lstVisitReason.length; z++) {
				var next = this.lstVisitReason[z];

				if (this.DefaultVisitReasonID == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.DefaultVisitReasonID = Number(temp);

		//
		//	Default_KeyboardMode
		//
		temp = -1;
		if (this.lstKeyboardMode.length > 0) {
			temp = this.lstKeyboardMode[0].ID;
			for (var z = 0; z < this.lstKeyboardMode.length; z++) {
				var next = this.lstKeyboardMode[z];

				if (this.Default_KeyboardMode == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.Default_KeyboardMode = Number(temp);

		//
		//	StationMode
		//
		temp = -1;
		if (this.lstStationMode.length > 0) {
			temp = this.lstStationMode[0].ID;
			for (var z = 0; z < this.lstStationMode.length; z++) {
				var next = this.lstStationMode[z];

				if (this.StationMode == next.ID) {
					temp = next.ID;
					break;
				}
			}
		}
		this.StationMode = Number(temp);

		//
		//  Default_FacilityLocationID
		//
		var temp = -1;
		if (this.lstFacilityLocation.length > 0) {
			temp = Number(this.lstFacilityLocation[0].ID);
			for (var z = 0; z < this.lstFacilityLocation.length; z++) {
				var next = this.lstFacilityLocation[z];

				if (next.ID == this.Default_FacilityLocationID) {
					temp = Number(next.ID);
				}
			}
		}
		this.Default_FacilityLocationID = temp;

		//
		//  Template_Default
		//  Template_VerificationReqd
		//  Template_OffenderHit
		//

		var temp_default = "";
		var temp_verreq = "";
		var temp_offender = "";
		if (this.lstIDCardTemplate.length > 0) {
			temp_default = String(this.lstIDCardTemplate[0].IDCardTemplateID);
			temp_verreq = String(this.lstIDCardTemplate[0].IDCardTemplateID);
			temp_offender = String(this.lstIDCardTemplate[0].IDCardTemplateID);

			for (var z = 0; z < this.lstIDCardTemplate.length; z++) {
				var next = this.lstIDCardTemplate[z];

				if (this.Template_Default == next.IDCardTemplateID) {
					temp_default = String(next.IDCardTemplateID);
				}
				if (this.Template_VerificationReqd == next.IDCardTemplateID) {
					temp_verreq = String(next.IDCardTemplateID);
				}
				if (this.Template_OffenderHit == next.IDCardTemplateID) {
					temp_offender = String(next.IDCardTemplateID);
				}
			}
		}
		this.Template_Default = temp_default;
		this.Template_VerificationReqd = temp_verreq;
		this.Template_OffenderHit = temp_offender;

		//
		//  SelectedVisitee
		//    DefaultVisiteeID
		//    DefaultVisiteeFacilityLocationID
		//
		if (this.lstVisitee.length > 0) {
			var tempPerson = this.lstVisitee[0];
			var tempLocation = this.lstVisitee[0];
			var vPersonFound = false;
			var vLocationFound = false;

			for (var z = 0; z < this.lstVisitee.length; z++) {
				var next = this.lstVisitee[z];

				if (next.VisiteeID == this.DefaultVisiteeID) {
					vPersonFound = true;
					tempPerson = next;
					break; // (Only Break for Visitee Person)
				}
				if (next.FacilityLocationID == this.DefaultVisiteeFacilityLocationID) {
					vLocationFound = true;
					tempLocation = next;
				}
			}

			if (vPersonFound == true) {
				this.SelectedVisitee = tempPerson;
			} else {
				this.SelectedVisitee = tempLocation;
			}
		} else {
			this.SelectedVisitee = null;
		}

		var temp = -1;
		if (this.lstPanicButtonTopic.length > 0) {
			temp = Number(this.lstPanicButtonTopic[0].ID);
			for (var z = 0; z < this.lstPanicButtonTopic.length; z++) {
				var next = this.lstPanicButtonTopic[z];

				if (next.ID == this.Default_PanicButtonTopicID) {
					temp = Number(next.ID);
				}
			}
		}
		this.Default_PanicButtonTopicID = temp;
	}

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadData();
	}

	onUpdate() {
		this.errorMessage = "";
		//
		//	Error Handling
		//

		//
		//	Make WS Request
		//
		var parms: FacilitySettingsUpdateRequest = {
			FacilityID: this.SelectedFacility.ID,
			A411_VisitorModeEnabled: this.A411_Facility_VisitorModeEnabled,
			A411_StudentModeEnabled: this.A411_Facility_StudentModeEnabled,
			A411_StaffModeEnabled: this.A411_Facility_StaffModeEnabled,
			A411_OffenderLookupEnabled: this.A411_Facility_OffenderLookupEnabled,
			VisitorModeEnabled: this.VisitorModeEnabled,
			VisitorModeCanOverride: this.VisitorModeCanOverride,
			StudentModeEnabled: this.StudentModeEnabled,
			StudentModeCanOverride: this.StudentModeCanOverride,
			StaffModeEnabled: this.StaffModeEnabled,
			StaffModeCanOverride: this.StaffModeCanOverride,
			OffenderLookupEnabled: this.OffenderLookupEnabled,
			OffenderLookupCanOverride: this.OffenderLookupCanOverride,
			PanicButtonEnabled: this.PanicButtonEnabled,
			PanicButtonCanOverride: this.PanicButtonCanOverride,
			ConfirmPanicButtonEnabled: this.ConfirmPanicButtonEnabled,
			ConfirmPanicButtonCanOverride: this.ConfirmPanicButtonCanOverride,
			PanicButtonText: this.PanicButtonText,
			PanicButtonTextCanOverride: this.PanicButtonTextCanOverride,
			ConfirmPanicButtonText: this.ConfirmPanicButtonText,
			ConfirmPanicButtonTextCanOverride: this.ConfirmPanicButtonTextCanOverride,
			Default_PanicButtonTopicID: this.Default_PanicButtonTopicID,
			PanicButtonTopicCanOverride: this.PanicButtonTopicCanOverride,
			PhotoRequired: this.PhotoRequired,
			PhotoRequiredCanOverride: this.PhotoRequiredCanOverride,
			SkipPhotoIfNotRequired: this.SkipPhotoIfNotRequired,
			SkipPhotoIfNotRequiredCanOverride: this.SkipPhotoIfNotRequiredCanOverride,
			UseDriversLicensePhoto: this.UseDriversLicensePhoto,
			UseDriversLicensePhotoCanOverride: this.UseDriversLicensePhotoCanOverride,
			AllowExistingPhoto: this.AllowExistingPhoto,
			AllowExistingPhotoCanOverride: this.AllowExistingPhotoCanOverride,
			ForceRetakePhotoAfterXDays: this.ForceRetakePhotoAfterXDays,
			ForceRetakePhotoCanOverride: this.ForceRetakePhotoCanOverride,
			Default_PrinterAlignTop: this.Default_PrinterAlignTop,
			Default_PrinterAlignLeft: this.Default_PrinterAlignLeft,
			PrintStudentLatePasses: this.PrintStudentLatePasses,
			PrintStudentLatePassesCanOverride: this.PrintStudentLatePassesCanOverride,
			PrintStudentEntryPasses: this.PrintStudentEntryPasses,
			PrintStudentEntryPassesCanOverride: this.PrintStudentEntryPassesCanOverride,
			SkipConfirmInfo: this.SkipConfirmInfo,
			SkipConfirmInfoCanOverride: this.SkipConfirmInfoCanOverride,
			SkipVisitorType: this.SkipVisitorType,
			SkipVisitorTypeCanOverride: this.SkipVisitorTypeCanOverride,
			DefaultVisitorTypeID: this.DefaultVisitorTypeID,
			DefaultVisitorTypeCanOverride: this.DefaultVisitorTypeCanOverride,
			SkipVisitee: this.SkipVisitee,
			SkipVisiteeCanOverride: this.SkipVisiteeCanOverride,
			DefaultVisiteeSchoolID: this.SelectedVisitee.SchoolID,
			DefaultVisiteeID: this.SelectedVisitee.VisiteeID,
			DefaultVisiteeCanOverride: this.DefaultVisiteeCanOverride,
			DefaultVisiteeFacilityLocationID: this.SelectedVisitee.FacilityLocationID,
			SkipVisitReason: this.SkipVisitReason,
			SkipVisitReasonCanOverride: this.SkipVisitReasonCanOverride,
			DefaultVisitReasonID: this.DefaultVisitReasonID,
			DefaultVisitReasonCanOverride: this.DefaultVisitReasonCanOverride,
			SkipAdditionalNotes: this.SkipAdditionalNotes,
			SkipAdditionalNotesCanOverride: this.SkipAdditionalNotesCanOverride,
			SkipSignature: this.SkipSignature,
			SkipSignatureCanOverride: this.SkipSignatureCanOverride,
			UseDriversLicenseSignature: this.UseDriversLicenseSignature,
			UseDriversLicenseSignatureCanOverride: this.UseDriversLicenseSignatureCanOverride,
			SelfCheckInVerifyText: this.SelfCheckInVerifyText,
			SelfCheckInVerifyTextCanOverride: this.SelfCheckInVerifyTextCanOverride,
			Default_KeyboardMode: this.Default_KeyboardMode,
			Default_FacilityLocationID: this.Default_FacilityLocationID,
			SyncDropdownMinutes: this.SyncDropdownMinutes,
			SyncDropdownMinutesCanOverride: this.SyncDropdownMinutesCanOverride,
			StationMode: this.StationMode,
			StationModeCanOverride: this.StationModeCanOverride,
			Template_OffenderHit: this.Template_OffenderHit,
			Template_VerificationReqd: this.Template_VerificationReqd,
			Template_Default: this.Template_Default,
			Template_OffenderHitCanOverride: this.Template_OffenderHitCanOverride,
			Template_VerificationReqdCanOverride: this.Template_VerificationReqdCanOverride,
			Template_DefaultCanOverride: this.Template_DefaultCanOverride,
		};

		this.Processing = true;
		var result = this.dataService.FacilitySettingsUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "facility",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Facility Settings were updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadData();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "facility",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update facility settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onResetToDistrict() {
		this.errorMessage = "";
	}

	onFinishResetToDistrict() {
		this.errorMessage = "";

		if (this.SelectedFacility == undefined || this.SelectedFacility.ID == undefined) {
			this.errorMessage = "Select a Facility";
			return;
		}

		this.Processing = true;
		var result = this.dataService.FacilitySettingsReset(this.SelectedFacility.ID);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "facility",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Facility Settings were reset successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadData();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "facility",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not reset facility settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////////////////

	onFacilityChange(val) {
		this.SelectedFacility = val;

		this.loadData();
	}

	//
	//  Can Override
	//
	onToggleVisitorModeCanOverride() {
		this.VisitorModeCanOverride = !this.VisitorModeCanOverride;
	}

	onToggleStudentModeCanOverride() {
		this.StudentModeCanOverride = !this.StudentModeCanOverride;
	}
	onToggleStaffModeCanOverride() {
		this.StaffModeCanOverride = !this.StaffModeCanOverride;
	}
	onToggleOffenderLookupCanOverride() {
		this.OffenderLookupCanOverride = !this.OffenderLookupCanOverride;
	}
	onTogglePanicButtonCanOverride() {
		this.PanicButtonCanOverride = !this.PanicButtonCanOverride;
	}
	onToggleConfirmPanicButtonCanOverride() {
		this.ConfirmPanicButtonCanOverride = !this.ConfirmPanicButtonCanOverride;
	}
	onTogglePanicButtonTextCanOverride() {
		this.PanicButtonTextCanOverride = !this.PanicButtonTextCanOverride;
	}
	onToggleConfirmPanicButtonTextCanOverride() {
		this.ConfirmPanicButtonTextCanOverride = !this.ConfirmPanicButtonTextCanOverride;
	}
	onTogglePanicButtonTopicCanOverride() {
		this.PanicButtonTopicCanOverride = !this.PanicButtonTopicCanOverride;
	}
	onTogglePhotoRequiredCanOverride() {
		this.PhotoRequiredCanOverride = !this.PhotoRequiredCanOverride;
	}
	onToggleSkipPhotoIfNotRequiredCanOverride() {
		this.SkipPhotoIfNotRequiredCanOverride = !this.SkipPhotoIfNotRequiredCanOverride;
	}
	onToggleUseDriversLicensePhotoCanOverride() {
		this.UseDriversLicensePhotoCanOverride = !this.UseDriversLicensePhotoCanOverride;
	}
	onToggleAllowExistingPhotoCanOverride() {
		this.AllowExistingPhotoCanOverride = !this.AllowExistingPhotoCanOverride;
	}
	onToggleForceRetakePhotoCanOverride() {
		this.ForceRetakePhotoCanOverride = !this.ForceRetakePhotoCanOverride;
	}
	onTogglePrintStudentLatePassesCanOverride() {
		this.PrintStudentLatePassesCanOverride = !this.PrintStudentLatePassesCanOverride;
	}
	onTogglePrintStudentEntryPassesCanOverride() {
		this.PrintStudentEntryPassesCanOverride = !this.PrintStudentEntryPassesCanOverride;
	}
	onToggleSkipConfirmInfoCanOverride() {
		this.SkipConfirmInfoCanOverride = !this.SkipConfirmInfoCanOverride;
	}
	onToggleSkipVisitorTypeCanOverride() {
		this.SkipVisitorTypeCanOverride = !this.SkipVisitorTypeCanOverride;
	}
	onToggleDefaultVisitorTypeCanOverride() {
		this.DefaultVisitorTypeCanOverride = !this.DefaultVisitorTypeCanOverride;
	}
	onToggleSkipVisiteeCanOverride() {
		this.SkipVisiteeCanOverride = !this.SkipVisiteeCanOverride;
	}
	onToggleDefaultVisiteeCanOverride() {
		this.DefaultVisiteeCanOverride = !this.DefaultVisiteeCanOverride;
	}
	onToggleSkipVisitReasonCanOverride() {
		this.SkipVisitReasonCanOverride = !this.SkipVisitReasonCanOverride;
	}
	onToggleDefaultVisitReasonCanOverride() {
		this.DefaultVisitReasonCanOverride = !this.DefaultVisitReasonCanOverride;
	}
	onToggleSkipAdditionalNotesCanOverride() {
		this.SkipAdditionalNotesCanOverride = !this.SkipAdditionalNotesCanOverride;
	}
	onToggleSkipSignatureCanOverride() {
		this.SkipSignatureCanOverride = !this.SkipSignatureCanOverride;
	}
	onToggleUseDriversLicenseSignatureCanOverride() {
		this.UseDriversLicenseSignatureCanOverride = !this.UseDriversLicenseSignatureCanOverride;
	}
	onToggleSelfCheckInVerifyTextCanOverride() {
		this.SelfCheckInVerifyTextCanOverride = !this.SelfCheckInVerifyTextCanOverride;
	}
	onToggleSyncDropdownMinutesCanOverride() {
		this.SyncDropdownMinutesCanOverride = !this.SyncDropdownMinutesCanOverride;
	}
	onToggleStationModeCanOverride() {
		this.StationModeCanOverride = !this.StationModeCanOverride;
	}
	onToggleTemplate_OffenderHitCanOverride() {
		this.Template_OffenderHitCanOverride = !this.Template_OffenderHitCanOverride;
	}
	onToggleTemplate_VerificationReqdCanOverride() {
		this.Template_VerificationReqdCanOverride = !this.Template_VerificationReqdCanOverride;
	}
	onToggleTemplate_DefaultCanOverride() {
		this.Template_DefaultCanOverride = !this.Template_DefaultCanOverride;
	}

	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.FacilityLoading == true || this.PreferenceLoading == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////////////////////////////////////
}
